<template>
    <pt-dialog
        v-model="props.visible"
        :title="t('experience.setting.update_design_title')"
        custom-class="editTemplateDialog"
        width="580px"
        :append-to-body="true"
        @close="handleClose"
    >
        <div class="dialog-content">
            <pt-form :model="templateInfo" label-position="top">
                <pt-form-item prop="name" :label="t('experience.setting.design_name')">
                    <pt-input
                        :class="$style.input"
                        size="large"
                        :maxLength="constantConfig.EXPERIENCE_TEMPLATE_NAME_MAX_LENGTH"
                        v-model="templateInfo.name"
                    ></pt-input>
                </pt-form-item>
                <pt-form-item prop="description" :label="t('experience.setting.design_desc')">
                    <pt-input
                        :class="$style.input"
                        size="large"
                        v-model="templateInfo.description"
                    ></pt-input>
                </pt-form-item>
                <!-- <pt-form-item v-if="templateInfo.deviceType.length === 1">
                    <pt-checkbox v-model="templateInfo.sync">
                        {{
                            templateInfo.deviceType.includes('PC')
                                ? t('experience.setting.save_both_pc')
                                : t('experience.setting.save_both_mobile')
                        }}
                    </pt-checkbox>
                </pt-form-item> -->
            </pt-form>
        </div>
        <template #footer>
            <pt-button :class="$style.btn" type="contain" color="grey" @click="handleClose">
                {{ t('common.button_cancel') }}
            </pt-button>
            <pt-button :disabled="!templateInfo?.name" @click="handleSave" class="pt-ml8">{{
                t('common.button_save')
            }}</pt-button>
        </template>
    </pt-dialog>
</template>
<script lang="ts">
export default {
    name: 'ExperienceTemplateEditDialog'
};
</script>

<script lang="ts" setup>
import { ref, watch, onMounted, computed } from 'vue';
import { cloneDeep } from 'lodash-es';
import type { ExperienceTemplateV4 } from '@models/experience/useExperienceTemplatesV4';
import constantConfig from '@experience/config/constant.config';
import { useI18n } from 'vue-i18n';
interface Props {
    visible: boolean;
    template: ExperienceTemplateV4 | null;
}

const props = defineProps<Props>();
const emit = defineEmits(['save', 'close']);

const { t } = useI18n();
const templateInfo = ref<ExperienceTemplateV4>({
    name: '',
    description: '',
    sync: false,
    deviceType: ['PC']
});

watch(
    () => props.template,
    () => {
        templateInfo.value = cloneDeep(props.template);
    }
);

onMounted(() => {
    templateInfo.value = cloneDeep(props.template);
});

function handleClose() {
    emit('close');
}

function handleSave() {
    emit('save', templateInfo.value);
}
</script>

<style lang="scss" module>
@import '@style/import.scss';
:global {
    .editTemplateDialog {
        .pt-form-item__label {
            line-height: 20px;
        }
    }
}
</style>
